import Rest from '../rest'

/******************************************************************************
 *  Products
 *****************************************************************************/

/**
 * @type {Product}
 */
export default class Product extends Rest {

    constructor () {
        super('/products')
    }

    search(string){
        return this.http.get(this.constructor.normalize(this.resource, '?name=' + string))
    }

    /**
     * Busca todos os produtos cadastrados no banco e formata-os para serem utilizados
     * em um select-tags
     */
    getProductOptions(config) {
        return this.getAll('', {}, config)
            .then(response => {
				if(response.data) {
					let productOptions = Object.values(response.data).map(product => {
						return { label: product.name, id: product.id, value: product.id }
					})
					response.data = [...productOptions]
				}
                return response
            })
    }

    /**
     * filtra os produtos
     *
     */
    searchProductFiltred(payload) {
        return this.http.get(this.constructor.normalize(this.resource, `search?name=${payload.name ? payload.name: ''}&per_page=${payload.per_page ? payload.per_page : ''}&page=${payload.page ? payload.page : ''}&items=${payload.items ? payload.items:''}`))
    }

    /**
     * Busca os dados de uma disponibilidade de acordo com a etapa 4
     *
     * @param {Integer|String} id
     */
    getAvailabilityStep4(id) {
        return this.http.get(
            this.constructor.normalize(this.constructor.normalize(this.resource, id), '/availabilityStep4')
        ).then(response => {
            if (response.data && response.data.status === 'error') return Promise.reject(response)

            return response
        })
    }

    /**
     * Busca os dados de uma disponibilidade com os fluxos limitados
     *
     * @param {Integer|String} id
     */
	getLimitedTableFlow(id, dealId) {
		return this.http.get(
			this.constructor.normalize(
				this.constructor.normalize(
					this.constructor.normalize(this.resource, id),
					'/availabilityStep4'
				),
				dealId ? `/limited/${dealId}` : '/limited'
			)
		).then(response => {
			if (response.data && response.data.status === 'error') return Promise.reject(response)

			return response
		})

	}

	/**
     * Busca os dados das unidades de uma quadra ou torre/andar de um produto
     *
     * @param {Integer|String} id
     * @param {String} type
     * @param {Integer|String} block
     * @param {Integer|String} floor
     */
	getBlockUnits(id, type, block, stage, launch) {
		return this.http.get(
			this.constructor.normalize(
				this.constructor.normalize(
					this.constructor.normalize(
						this.constructor.normalize(
							this.constructor.normalize(this.resource, id),
							'block'
						),
						block
					),
					stage
				),
				launch ? `${type}/${launch}` : type
			)
		)
	}

	getProductWithoutAvailable(params = {}){
		return this.http.get('product/withoutAvailable', { params })
	}

	/**
     * Busca todos os dados de um determinado empreendimento
     *
     * @param {Integer|String} id
     */
     getAvailability(id) {
        return this.http.get(
            this.constructor.normalize(this.constructor.normalize(this.resource, id), '/availability')
        ).then(response => {
            if (response.data && response.data.status === 'error') return Promise.reject(response)

            return response
        })
    }

    /**
     * Busca os dados das unidades de uma quadra/torre
     *
     * @param {Integer|String} id
     * @param {Integer|String} stage
     * @param {String} type
     */
     getUniqueBlockUnits(id, stage, type) {
        return this.http.get(
            this.constructor.normalize(
                this.constructor.normalize(
                    this.constructor.normalize(
                        this.constructor.normalize(this.resource, id),
                        'block'
                    ),
                    stage
                ),
                type
            ),
        )
    }

	/**
	 * Retorna todos os empreendimentos com o sistema de reserva ativo
	 *
	 * @returns {Promise}
	 */
	getHasReserve() {
		return this.http.get('products/has/reserve').then(res => {
			// Cria a varíabel "label" para ser usada no filtro de empreendimento
			// da lista de reservas. Formatando para select-tags.
			res.data.map(product => {
				product.label = product.name
			})

			return res
		})
	}

	/**
	 * Retorna as informações de quadra/torre de um empreendimento
	 *
	 * @param {int} productId
	 * @returns {Promise}
	 */
	getBlocks(productId) {
		return this.http.get(`availability/${productId}/blocks`)
	}

	/**
	 * Retorna todas as unidades de uma quadra/torre
	 *
	 * @param {int} productId
	 * @param {int} block
	 * @returns {Promise}
	 */
	getAvailabilityBlockUnits(productId, block) {
		return this.http.get(`availability/${productId}/block/${block}`)
	}

	/**
	 * Retorna as informações de um empreendimento UAU
	 *
	 * @param {int} uauBusinessKey
	 * @param {int} uauProductKey
	 * @param {int} uauProductType
	 * @param {int} productId
	 * @returns {Promise}
	 */
	getUAUBlocksUnits(uauBusinessKey, uauProductKey, uauProductType, productId) {
		return this.http.get(`integrations/apiuau/list/${uauBusinessKey}/${uauProductKey}/${uauProductType}/${productId}`)
	}

	/**
	 * Retorna as informações de determinada unidade
	 *
	 * @param {int} unityId
	 * @returns {Promise}
	 */
	getUnity(unityId) {
		return this.http2.get(`availability/units/${unityId}`)
	}
	/**
     * Busca todos os dados de um determinado empreendimento sem ter as unidades
     *
     * @param {Integer|String} id
     */
     getProducts(id) {
        return this.http.get(`products/${id}`)
        .then(response => {
            if (response.data && response.data.status === 'error') return Promise.reject(response)

            return response
        })
    }
	/**
     * Busca um produto baseado na disponibilidade
     *
     * @param {Integer|String} id
	 * @returns {Promise}
     */
	// getProductByAvailability(id){
	// 	return this.http2.get(`availability/${id}`)
	// 		.then(response => {
	// 			if (response.data && response.data.status === 'error') return Promise.reject(response);
	// 				return response
	// 		})
	// }

	listUnitsPermissions(id) {
        return this.http2.get(`products/${id}/units/permissions`)
        .then(response => {
            if (response.data && response.data.status === 'error') return Promise.reject(response)

            return response
        })
	}

	postPermissionsUnits(id, data) {
        return this.http2.post(`permission-units/${id}`, data)
        .then(response => {
            if (response.data && response.data.status === 'error') return Promise.reject(response)

            return response
        })
	}

	listProductConfiguration(id) {
        return this.http2.get(`product-message/${id}`)
        .then(response => {
            if (response.data && response.data.status === 'error') return Promise.reject(response)

            return response
        })
	}

	postProductConfiguration(id, data) {
        return this.http2.post(`product-message/${id}`, data)
        .then(response => {
            if (response.data && response.data.status === 'error') return Promise.reject(response)

            return response
        })
	}
}